import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Router from "next/router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { logEvents } from "../../../../redux/commonActions";
import { DASHBOARD } from "../../../../routes/RouteConstants";
import { PROFILE_BACK_CLICKED } from "../../../../services/webengage/webEngageConstants";

const styles = () => ({
  root: {
    position: "relative",
    top: 38,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    ["@media (max-width:576px)"]: { marginLeft: 7, position: "initial" }
  },
  img: {
    marginLeft: "0px",
    marginRight: "12px",
    width: "15.52px",
    height: "11.64px",
    ["@media (max-width:576px)"]: { width: "18px", height: "14px" }
  },
  text: {
    fontFamily: "Source Sans Pro",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "18px",
    color: "#898F9D",
    ["@media (max-width:576px)"]: {
      display: "none"
    }
  }
});

const GoToJobs = ({ classes, logEvents }) => (
  <div
    className={classes.root}
    onClick={() => {
      logEvents(PROFILE_BACK_CLICKED);
      Router.push(DASHBOARD);
    }}
  >
    <img src="/hire/arrow-left.svg" alt="back-button" className={classes.img} />
    <div className={classes.text}>Back to Jobs</div>
  </div>
);

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ logEvents }, dispatch);
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(GoToJobs));
